import { region, pagination } from "./templates";

export default {
	regions: [],
	region: { ...region},
	pagination: { ...pagination }
};
